module.exports = __webpack_public_path__ + "static/commercial-pollution-insurance-79303f41281aa9a0036d3808e924ddd3.svg";